<div class="mb-2" *ngIf="draftCount > 0">
    <button #btn class="btn draft-toggle" [ngClass]="showDrafts ? 'btn-outline-primary' : 'btn-outline-primary draft-btn'" (click)="toggle(); btn.blur()">
        <ng-container *ngIf="!showDrafts">
            <div class="d-flex flex-row align-items-center justify-content-between w-100">
                <div class="d-flex flex-row">
                    <i class="fa fa-pencil-square-o me-2 mt-1"></i>
                    <span>View Drafts</span>
                </div>
                <span class="badge"
                      [class.draft-badge]="badgeDigitCount > 1"
                      [class.draft-badge-sm]="badgeDigitCount <= 1"
                      style="border-radius: 50%; min-width: 1.75em; text-align: center; font-size: 0.75rem;">
                    {{draftCount}}
                </span>
            </div>
        </ng-container>
        <ng-container *ngIf="showDrafts">
            <i class="fa fa-arrow-left me-2"></i>Back to Completed Applications
        </ng-container>
    </button>
</div>
